document.querySelectorAll('a[data-js="scrollTo"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        const header = document.querySelector('.js-site-header');
        const offset = header.offsetHeight;

        const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset - 100;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    });
});
